import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';
import type { User } from '@/types';

export async function getMemberDetails(userId: string): Promise<User | null> {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (!userDoc.exists()) return null;

    const data = userDoc.data();
    return {
      id: userDoc.id,
      ...data,
      createdAt: data.createdAt?.toDate(),
      updatedAt: data.updatedAt?.toDate(),
      roles: data.roles?.map((role: any) => ({
        ...role,
        assignedAt: role.assignedAt?.toDate()
      }))
    } as User;
  } catch (error) {
    handleFirebaseError(error, 'Error fetching member details');
    return null;
  }
}